import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../api/axios';
import { clarityEvent } from '../utils/clarity';
import './AuthForm.css';

const ForgotPassword = () => {
    const [identifier, setIdentifier] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            const response = await authService.post('/auth/forgot-password', { emailOrUsername: identifier });
            clarityEvent('forgot_password_submitted');
            setMessage(response.data);
            setIdentifier(''); // Clear the input
        } catch (err) {
            setError(err.response?.data || 'Failed to send reset link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        // Added flex layout here to center the content
        <div className="auth-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>

            {/* Added flex: 'none' and a subtle box-shadow/border-radius for standalone appearance */}
            <div className="auth-form-panel" style={{ width: '100%', maxWidth: '450px', flex: 'none', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>

                <div className="auth-form-container">
                    <Link to="/login" className="back-home-link" style={{ marginBottom: '20px', display: 'inline-block' }}>← Back to Login</Link>
                    <h2>Forgot Password</h2>
                    <p className="form-subtitle">Enter your username or email and we'll send you a link to reset your password.</p>

                    {message && <p className="success-message" style={{ color: 'green', marginBottom: '15px' }}>{message}</p>}
                    {error && <p className="error-message">{error}</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="input-group">
                            <input
                                type="text"
                                className="auth-input"
                                placeholder="Username or Email"
                                value={identifier}
                                onChange={(e) => setIdentifier(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className="auth-button-primary" disabled={loading} style={{ marginTop: '10px' }}>
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;